module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-800-8194b93e0711c82dbb95987254acb20d.webp";